import {h, Fragment} from "preact"
import { useAppState, useActions } from "@nosto/preact";
import { useEffect, useState } from "preact/hooks";
import { sortOptions } from '../config'
import Facet from './Facet'
import RangeFacet from './RangeFacet'
import ActiveFilters from "./ActiveFilters"

export default ({ openFilter, setOpenFilter }) => {
    const { loading, response: { products: { facets }, products } = {} } = useAppState()
    const { updateSearch } = useActions();

    const activeFilters = [];
    const [active, setActive] = useState(false);

    console.log("FACETS", facets);

    facets?.filter(f => f.data).forEach(data => {
        data.data.forEach(v => {
            if (v.selected) {
                activeFilters.push({
                    facetName: data.name,
                    facetField: data.field,
                    value: v.value
                })
            }
        })
    })

    useEffect(() => {
        if (openFilter) {
            document.querySelector("body").style.overflow = "hidden"
        }
    }, [openFilter])

    return (
        <>
            
            <span
                style={{
                    visibility: openFilter ? 'visible' : 'hidden',
                    opacity: openFilter ? '1' : '0',
                    transition: 'all 0.2s ease-in-out',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    zIndex: openFilter ? 5600 : 0,
                    background: 'rgba(0, 0, 0, 0.4)'
                }}
                onClick={() => {
                    setOpenFilter(false)
                    document.querySelector("body").style.overflow = "visible"
                }}
            />
            

            <div
                class={`ns-sidebar-wrapper ns-h-100 ns-col-3 ns-col-l-2 ${openFilter ? 'active' : ''}`}
            >
                <div style={{ zIndex: 2}}>
                    <div class="ns-sidebar-outer-heading">
                        <span
                            className={`ns-img-arrows ns-icon ns-icon-arrow-right ns-back ns-absolute`}
                            onClick={() => {
                                setOpenFilter(false)
                                document.querySelector("body").style.overflow = "visible"
                            }}
                        />
                    </div>
                    <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                        <div class="ns-sidebar-header">
                            <div class="ns-sidebar-filterby">
                                {activeFilters.length > 0 && (
                                    <a
                                        href="javascript:void(0)"
                                        class="ns-clear-all ns-font-5"
                                        style={{color:'black'}}
                                        onClick={() => {
                                            updateSearch({
                                                products: {
                                                    filter: [],
                                                },
                                            })
                                        }}
                                    >
                                        Clear All
                                    </a>
                                )}
                            </div>
                            <ActiveFilters
                                products={products}
                                facets={facets}
                                activeFilters={activeFilters}
                            />
                        </div>
                        <div class="ns-sidebar-menu">
                            <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                                {/* sort */}
                                <li className={`ns-sidebar-dropdown ${active ? 'ns-active' : ''}`}>
                                    <a
                                        class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-py-4 ns-accordion-panel ns-d-flex ns-justify-content-between"
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            setActive(!active)
                                        }}
                                    >
                                        <span class="ns-facet-name ns-font-4">Sort by</span>
                                        <span class="plusminus"></span>
                                    </a>
                                    <div class="ns-sidebar-submenu">
                                        <ul class="ns-list-unstyled ns-p-0 ns-m-0 ns-facet-list-container ns-d-flex ns-flex-column ns-gap-4 ns-mt-4">
                                            {sortOptions.map((o) => (
                                                <li value={o.id} name={o.value.name} class="ns-d-flex ns-align-items-center ns-font-3 ns-facet-container" onClick={(e) => {
                                                    e.stopPropagation();

                                                    updateSearch({
                                                        products: {
                                                            sort: sortOptions.find(
                                                                (v) => v.id === o.id
                                                            )?.value?.sort,
                                                        },
                                                    })

                                                }}>
                                                    <span class="ns-facet-item">{o.value.name}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>

                                {facets?.filter(facet => facet.name !== "Resale").map((facet) => {
                                    switch (facet.type) {
                                        case 'terms':
                                            return <Facet facet={facet} />
                                        case 'stats':
                                            return <RangeFacet facet={facet} />
                                        default:
                                            return null
                                    }
                                })}
                            </ul>
                            <div
                                style={{width: '100%', height: 'auto', paddingTop: 12, paddingBottom: 12, background: 'black', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'inline-flex', cursor: 'pointer'}}
                                onClick={() => {
                                    setOpenFilter(false)
                                    document.querySelector("body").style.overflow = "visible"
                                }}
                            >
                                <div style={{color: 'white', fontSize: 16}}>Show Products</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}